var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.8,
    fillRule: "evenodd",
    d: "M4.629 17.16a9.018 9.018 0 1 1 2.21 2.212l-2.842.631zm7.313-8.413c.753-.041 1.4.526 1.46 1.274-.01.35-.252.641-.799 1.086l-.14.112c-.214.172-.469.376-.668.584-.25.262-.544.66-.544 1.197a.75.75 0 0 0 1.5.01.6.6 0 0 1 .128-.17c.123-.13.276-.252.48-.415l.19-.154c.518-.42 1.353-1.126 1.353-2.272q0-.022-.002-.046a2.887 2.887 0 0 0-3.004-2.705 2.93 2.93 0 0 0-2.941 2.267.75.75 0 1 0 1.461.34 1.43 1.43 0 0 1 1.454-1.107zm.059 8.084a.754.754 0 1 0 0-1.509.754.754 0 0 0 0 1.51",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.cb71d8110ac6add269943f9fe55f8065.svg";
export { ForwardRef as ReactComponent };